import { encodePlayerName } from '~/redux/ducks/playersAndTeams/filter/selectors/getFiltersAsCayenneParams';
import { ReportCategory } from '~/redux/enums';
import { fetchStatsData } from '~/utility/requests';

import { Player, PlayerOption } from './types';

const convertToSelectablePlayers = (players: Array<Player>): Array<PlayerOption> =>
    players.map((player) => ({
        value: player.id,
        label: `${player.firstName} ${player.lastName}`,
        key: player.id,
        currentTeamId: player.currentTeamId,
        positionCode: player.positionCode,
        sweaterNumber: player.sweaterNumber,
        team: player.team
    }));

const getPlayers = async (playerName: string, reportCategory: string) => {
    if (!playerName) {
        return [];
    }

    // We will allow the user to select a string shorter than 4 characters
    const defaultPlayer: Array<PlayerOption> = [{ value: playerName, label: playerName, key: playerName, isSearchValue: true }];
    if (playerName.length < 4) {
        return defaultPlayer;
    }

    try {
        const position =
            reportCategory === ReportCategory.Skater
                ? encodeURIComponent(" and positionCode <> 'G'")
                : encodeURIComponent(" and positionCode = 'G'");

        const playerSearch = encodePlayerName(playerName, 'fullName', true);
        // Players with a team will be sorted first
        const playersUrl = `${window.__BASE_REST_URL__}/players?cayenneExp=${playerSearch}${position}&include=team.triCode&sort=[{"property":"team","direction":"DESC"},{"property":"firstName"},{"property":"lastName"}]`;
        const { data } = await fetchStatsData(playersUrl);
        const playerExist = data.find((p) => p.fullName.toUpperCase() === playerName.toUpperCase());
        return playerExist ? convertToSelectablePlayers(data) : [...defaultPlayer, ...convertToSelectablePlayers(data)];
    } catch (error) {
        return defaultPlayer;
    }
};

export default getPlayers;
